import script from "./Alias.vue?vue&type=script&setup=true&lang=js"
export * from "./Alias.vue?vue&type=script&setup=true&lang=js"

import "./Alias.vue?vue&type=style&index=0&id=206bc779&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206bc779"]])

export default __exports__